<template src="./index.html"></template>
<script>
	import {getdata} from "./data.js";
	import cztdInvoice from "./cztdInvoice/index.vue";
	import {
		cztdquery,
		queryNsrinfo,
		detailcztdadd,
		cztdsingleQuery,
		detailsingleQuery,
		cztdupdate,
		cztdclear,
		startTaxGather
	} from '../../../../../../api/cztds.js'
	import {MainFunction} from '../../../../../../components/util/Function/MainFunction.js'
	import config from '../../../../../../../configHttp.js'
	// import chensghi from '../../../../../../../../front/src/components/util/Function/chengshi.js'
	export default {
		name: "",
		components: {
			cztdInvoice,
		},
		props: {
			mxsearch: {
				type: Object,
				default: {},
			},
			searchdata: {
				type: Object,
				default: {},
			},
			outlistx: {
				type: Object,
				default: {},
			},
		},
		data: function() {
			return {
					maplist:[
					{
						value:null,
						item:'未采集'
					},
					{
						value:1,
						item:'未采集'
					},
					{
						value:2,
						item:'采集成功'
					},
					{
						value:3,
						item:'采集失败'
					},
					{
						value:4,
						item:'采集中'
					}
				],
				MainFunction:MainFunction,
				headData: getdata().headData,
				pagination: getdata().pagination,
				paramsx: getdata().paramsx,
				tableData: [{}],
				shaidiag: false,
				invoicediag: false,
				tablekey: 0,
				nasrsbhlist: [],
				conpid:'',
				shoudata: 1,
				tabjson: getdata().tabjson
			};
		},
		mounted() {
			queryNsrinfo().then(res => {
				if (res.data.code == 1) {
					this.nasrsbhlist = res.data.data
				} else {
					this.$message.error(res.data.msg)
				}
			})
			this.chpage()
		},
		created() {
		},
		methods: {
			Shui(e){
				this.$showConfirm({
					message: "是否上传税源至税局?",
				}).then((res) => {
					if (res == "confirm") {
						let params = {
							type:'1',
							detailIds:e.id
						}
						startTaxGather(params).then(res=>{
							if(res.data.code == 1 ){
								this.chpage();
							}else{
								this.$message.error(res.data.msg)
							}
						})
					}
				});
		},
			updata(){
				this.chpage()
				this.$forceUpdate()
			},
			getJxzcInfo() {
				this.chpage()
			},
			dsc(e) {
				this.$showConfirm({
					message: "确认删除?",
				}).then((res) => {
					if (res == "confirm") {
						let out = [e.id]
						this.dreremove(out)
					}
				});

			},
			psc() {
				for(let index = 0 ; index < this.$refs.tablebox.getSelectionval().length ; index++){
				if(this.$refs.tablebox.getSelectionval()[index].caijFlag == '4' ){
					return this.$message.error('不能删除正在采集的数据')
				}
			}
				this.$showConfirm({
					message: "确认删除?",
				}).then((res) => {
					if (res == "confirm") {
						let out = this.$refs.tablebox.getSelectionval()
						let duoxuan = []
						if (out.length == 0) {
							this.$message.error('请勾选您需要删除的数据')
						} else {
							out.map(item => {
								duoxuan.push(item.id)
							})
							this.dreremove(duoxuan)
						}
					}
				});
			},
			dreremove(e) {
				let params = {
					id: this.outlistx.id,
					suosq: this.outlistx.suosq,
					mxIds: e
				}
				cztdclear(params).then(res => {
					if (res.data.code == 1) {
						this.chpage()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			dc() {
				let out = this.$refs.tablebox.getSelectionval()
				let paramsx = []
				out.map(item => {
					paramsx.push(item.id)
				})
				let params = {
					downUrl: config.baseURL + "/land/detail/cztd/export",
					typeObj: {
						toForm: false,
						fileType: 'xlsx',
            fileName: "明细城镇土地使用税" + this.$timestampToStr(new Date(), "yyyyMMdd"),
					},
					params: {
						taxDetailCztdsysExtendSearchInputDTO: {
							nsrlx: this.searchdata.nsrlx,
							tudmc: this.searchdata.tudmc,
							landId: this.outlistx.id
						},
						ids: paramsx,
						json: this.tabjson
					}
				}
				this.$downloadcommon(params)
			},
			nextxz(e) {
				for (let a = 0 ; a < e.jianms.length ; a ++){
					if(!e.jianms[a].jianmdmhmc||e.jianms[a].jianmdmhmc==''||!e.jianms[a].tudmj||e.jianms[a].tudmj==''||!e.jianms[a].jianmje||e.jianms[a].jianmje==''){
						console.log(e.jianms)
						e.jianms.splice(a,1)
						a--
					}
				}
				if (this.shoudata > 1) {
					e.landId = this.outlistx.id
					detailcztdadd(e).then(res => {
						if (res.data.code == 1) {
							this.chpage()
							this.invoicediag = false
						} else {
							this.$message.error(res.data.msg)
						}
					})
				} else {
					e.id = this.conpid
					cztdupdate(e).then(res => {
						if (res.data.code == 1) {
							this.chpage()
							this.invoicediag = false
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}
			},
			xzlog(e) {
				console.log(this.paramsx)
				Object.keys(this.paramsx).map(key => {
					if (key != 'jianms') {
						this.paramsx[key] = ''
					} else {
						for(let index = this.paramsx.jianms.length ; index < 3 ; index++){
							this.paramsx.jianms.push({
								jianmdmhmc: "",
								jianmje: "",
								jianmqsyf:"",
								jianmzzyf: "",
								tudmj: "",
							})
						}
						this.paramsx.jianms.map(item => {
							Object.keys(item).map(item1 => {
								item[item1] = ''
							})
						})
					}
				})
				this.invoicediag = true
				if(this.shoudata<1){
					this.shoudata = 1
				}
				this.shoudata += 1
			},
			bj(e) {
				let params = {
					id: e.id
				}
				cztdsingleQuery(params).then(res => {
					if (res.data.code == 1) {
						let leng = res.data.data.jianms.length
						if(leng<3){
							for(let a = 0 ; a < 3 - leng ; a++){
								res.data.data.jianms.push({
									jianmdmhmc:'',
									jianmqsyf:null,
									jianmzzyf:null,
									tudmj:'',
									jianmje:'',
								})
							}
						}
						this.paramsx = res.data.data
						if(this.shoudata > 1){
							this.shoudata = 1
						}
						this.shoudata = this.shoudata - 1
						this.conpid = e.id
						this.invoicediag = true
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			chpage(e) {
				let params = JSON.parse(JSON.stringify(this.searchdata));
				params.current = this.pagination.pageNum;
				params.size = this.pagination.pageSize;
				params.suosq = this.outlistx.suosq
				params.landId = this.outlistx.id
				params.nsrsbh = this.outlistx.nsrsbh
				if (e) {
					this.pagination.pageNum = 1
					this.pagination.paginationkey++
				}
				cztdquery(params).then(res => {
					if (res.data.code == 1) {
						res.data.data.records.map(item => {
							if (item.nsrlx) {
								this.mxsearch.cztdNsrxz.map(item1 => {
									if (item.nsrlx == item1.value) {
										item.nsrlx = item1.label
									}
								})
								this.mxsearch.cztdTdbglxXxxbg.map(item2 => {
									if (item.nsrlx == item2.value) {
										item.nsrlx = item2.label
									}
								})
							}
							if (item.tudxz) {
								this.mxsearch.cztdTdxz.map(item1 => {
									if (item.tudxz == item1.value) {
										item.tudxz = item1.label
									}
								})
							}
							if (item.tudyt) {
								this.mxsearch.cztdTdyt.map(item1 => {
									if (item.tudyt == item1.value) {
										item.tudyt = item1.label
									}
								})
							}
							if (item.tudqdfs) {
								this.mxsearch.cztdTdqdfs.map(item1 => {
									if (item.tudqdfs == item1.value) {
										item.tudqdfs = item1.label
									}
								})
							}
						})
						this.pagination.total = res.data.data.total
						this.tableData = res.data.data.records
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			sizechange(e) {
				this.pagination.pageSize = e;
				this.chpage()
			},
			currentChange(e) {
				this.pagination.pageNum = e;
				this.chpage()
			},
			closediag() {
				this.invoicediag = false;
			},
		},
	};
</script>

<style scoped lang="less">
	@import url("./index.less");
</style>
